export const SOUND_CHOICES = ['homechat', 'silent'] as const;
export type SoundChoice = typeof SOUND_CHOICES[number];
export type SoundKind = 'messages' | 'calls';
const current: Partial<Record<SoundKind, SoundChoice>> = {};

function parseChoice(kind: SoundKind, value: string | null): SoundChoice {
  return SOUND_CHOICES.find((choice) => choice === value) ?? (kind === 'messages' ? 'silent' : 'homechat');
}

export function getSoundChoice(kind: SoundKind): SoundChoice {
  if (current[kind] !== undefined) return current[kind];
  try {
    return parseChoice(kind, localStorage.getItem('hc_sound_' + kind));
  } catch {
    return parseChoice(kind, null);
  }
}

export function setSoundChoice(kind: SoundKind, choice: SoundChoice): void {
  current[kind] = parseChoice(kind, choice);
  try {
    localStorage.setItem('hc_sound_' + kind, current[kind]);
  } catch {
    // При недоступном хранилище выбор действует до перезагрузки страницы.
  }
}
